"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Defer;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * Creates a new `Defer`red object,
 * @returns {Defer}
 */
function Defer() {
  var _this = this;
  this.promise = new _promise.default(function (resolve, reject) {
    /**
     * @instance
     * @memberof Defer
     * @type {function}
     */
    _this.resolve = resolve;
    /**
     * @instance
     * @memberof Defer
     * @type {function}
     */
    _this.reject = reject;
  });
}
//# sourceMappingURL=defer.js.map
